import { nanoId } from '@/helpers'
import Vue from 'vue'

const deliveryNote = () => {
  return {
    type: 7,
    data: null
  }
}

export const SET_TYPE = (state, { key, value }) => {
  state._[key].type = value
}

export const SET_DATA = (state, { key, value }) => {
  state._[key].data = value
}

export const ADD = (state, payload = undefined) => {
  let key = nanoId(8)
  state.list.push(key)
  if (!payload) payload = deliveryNote()
  Vue.set(state._, key, Object.assign({}, payload))
}

export const DELETE = (state, key) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}
